import React from "react";

class App extends React.Component {
  render() {
    return <></>;
  }
}

export default App;
